import { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import { path } from 'ramda'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import SuiteInfo from '@/features/Listing/suite-info'
import PADTenantPaymentHistory from '@/features/Payments/tenant-pad-payment'
import { select } from '@/store'
import PadPaymentRequest from './pad-payment-request'
import usePayment from './use-payment'

const PadPayment = ({
  match: {
    params: { listingId, paymentId }
  },
  history
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const paymentData = usePayment({ paymentId, listingId })

  const contractId = useSelector(path(['listing', listingId, 'contract', 'listing_contract_id']))
  const contract = useSelector(state => select.contract.contractView(state, { contractId }))

  useEffect(() => {
    if (contractId) {
      dispatch.contract.load(contractId)
    }
  }, [contractId, dispatch.contract])

  if (!paymentData) return null
  const isPadActive = contract.pad_active
  const isPadRequested = contract.pad_requested
  const isPadPending = isPadRequested && !isPadActive

  return (
    <>
      <Helmet>
        <title>{t('b.payments.view.payments.title', 'Payments')}</title>
      </Helmet>
      <SuiteInfo listingId={listingId} />
      {isPadPending ? (
        <PadPaymentRequest paymentData={paymentData} listingId={listingId} paymentId={paymentId} />
      ) : (
        <PADTenantPaymentHistory
          paymentData={paymentData}
          listingId={listingId}
          history={history}
        />
      )}
    </>
  )
}

export default PadPayment
